var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.12472 2.125H13.8749C14.4271 2.125 14.8748 2.57264 14.8749 3.12487L14.8749 3.83569C14.875 4.10097 14.7696 4.35538 14.582 4.54295L10.2093 8.91544C10.0218 9.10297 9.91639 9.35734 9.91639 9.62256V13.5942C9.91639 14.2448 9.305 14.7222 8.67385 14.5644L7.84052 14.356C7.39535 14.2447 7.08306 13.8448 7.08306 13.3859L7.08306 9.62255C7.08306 9.35733 6.9777 9.10298 6.79016 8.91544L2.41761 4.54289C2.23008 4.35536 2.12472 4.101 2.12472 3.83579V3.125C2.12472 2.57272 2.57244 2.125 3.12472 2.125Z",
    stroke: "#6C6F74",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8d935ab2aff03395b647979a45591ccd.svg";
export { ForwardRef as ReactComponent };